const fuseSettingsConfig = {
  layout: {
    style: 'layout1',
    config: {
      scroll: 'content',
      navbar: {
        display: true,
        folded: true,
        position: 'left'
      },
      toolbar: {
        display: true,
        style: 'fixed',
        position: 'below'
      },
      footer: {
        display: false,
        style: 'fixed',
        position: 'below'
      },
      leftSidePanel: {
        display: true
      },
      rightSidePanel: {
        display: true
      },
      mode: 'fullwidth'
    }
  },
  customScrollbars: true,
  theme: {
    main: 'default',
    navbar: 'mainThemeDark',
    toolbar: 'mainThemeLight',
    footer: 'mainThemeDark'
  }
}

const anexsysConfig = {
  layout: {
    style: 'layout2',
    config: {
      scroll: 'content',
      navbar: {
        display: true,
        folded: true,
        position: 'left'
      },
      toolbar: {
        display: false
      },
      footer: {
        display: false
      },
      leftSidePanel: {
        display: false
      },
      rightSidePanel: {
        display: false
      },
      mode: 'fullwidth'
    }
  },
  customScrollbars: true,
  theme: {
    main: 'anexsys',
    navbar: 'mainThemeDark',
    toolbar: 'mainThemeDark',
    footer: 'mainThemeDark'
  }
}

const _BRAND = anexsysConfig
export default (() => {
  return process.env.BRAND || _BRAND || fuseSettingsConfig
})()
